import { buildQueryParams } from 'helpers/buildQueryParams';

export function getUrl(domain, short_code, params = {}) {
  if (!short_code) {
    return `${domain}/white_page`;
  }
  return `${domain}/${short_code}?${buildQueryParams(params)}`;
}



// WEBPACK FOOTER //
// ./src/helpers/getUrl.js